'use strict';

class Media {
    static prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
}

class Timeout {
    constructor() {
        this.isSet = false;
        this.id    = null;
    }

    // https://dev.to/monaye/refactor-davidwalsh-s-debounce-function-5afc
    static debounce(func, delay, immediate) {
        let timer;
        return (...args) => {
            const boundFunc = func.bind(this, ...args);
            clearTimeout(timer);
            if (immediate && !timer) {
                boundFunc();
            }
            const calleeFunc = immediate ? () => { timer = null; } : boundFunc;
            timer            = setTimeout(calleeFunc, delay);
        };
    }

    static throttle(func, delay, immediate) {
        let timer;
        return (...args) => {
            const boundFunc = func.bind(this, ...args);
            if (timer) {
                return;
            }
            if (immediate && !timer) {
                boundFunc();
            }
            timer = setTimeout(() => {
                if (!immediate) {
                    boundFunc();
                }
                timer = null;
            }, delay);
        };
    }

    // https://davidwalsh.name/javascript-debounce-function

    set(fn, interval, scope, args) {
        scope = scope || window;

        const self = this;
        const wrap = function() {
            self.clear();
            fn.apply(scope, args || arguments);
        };

        this.id    = setTimeout(wrap, interval);
        this.isSet = true;
    }

    clear() {
        clearTimeout(this.id);
        this.isSet = false;
        this.id    = null;
    }
}

((doc, win, loc, $) => {
    const addEvent       = 'addEventListener';
    const parent         = 'parentNode';
    const addClass       = 'addClass';
    const removeClass    = 'removeClass';
    const hasClass       = 'hasClass';
    const preventDefault = 'preventDefault';

    const dawa = win.dawa;

    const key_codes = {
        TAB:         9,
        ENTER:       13,
        SHIFT:       16,
        CTRL:        17,
        ALT:         18,
        CAPSLOCK:    20,
        ESCAPE:      27,
        SPACE:       32,
        PAGE_UP:     33,
        PAGE_DOWN:   34,
        END:         35,
        HOME:        36,
        LEFT_ARROW:  37,
        UP_ARROW:    38,
        RIGHT_ARROW: 39,
        DOWN_ARROW:  40,
        INSERT:      45,
    };

    let submitted_forms = [];

    const validateFormElement = (e, $form_element, exclude_types, callback) => {
        if (!$form_element) {
            return;
        }
        if (!exclude_types) {
            exclude_types = ['submit'];
        }
        if (!callback) {
            callback = () => {};
        }

        let elements    = [];
        let any_empties = false;
        $form_element.toArray().forEach(function(el) {
            if (exclude_types.indexOf(el.type) === -1 && el.required) {
                elements.push(el);

                if (el.type === 'radio') {
                    if ($form_element[el.name].value.length === 0) {
                        $[addClass](el, 'error');
                        any_empties = true;
                    }
                } else if (el.type === 'checkbox') {
                    if ($form_element[el.name].checked === false) {
                        $[addClass](el, 'error');
                        any_empties = true;
                    }
                } else if (el.value === '') {
                    $[addClass](el, 'error');
                    el[addEvent]('keyup', event_keyup => {
                        if (event_keyup.target.value.length > 0) {
                            $[removeClass](event_keyup.target, 'error');
                        }

                    });
                    any_empties = true;
                } else {
                    $[removeClass](el, 'error');
                }
            }
        });
        if (any_empties === true) {
            e[preventDefault]();
        } else {
            if (submitted_forms.indexOf($form_element) !== -1) {
                e[preventDefault]();
                return;
            }
            submitted_forms.push($form_element);
        }

        callback(e, elements, any_empties);
    };

    /**
     * This validates $form_element for empty fields, excluding exclude_types fields
     */
    const validateForm = ($form_element, exclude_types, callback) => {
        if (!$form_element) {
            return;
        }

        $form_element[addEvent](
            'submit',
            e => validateFormElement(e, $form_element, exclude_types, callback),
        );
    };

    // eslint-disable-next-line complexity, max-statements
    $.documentReady(() => {
        const $html              = doc.documentElement;
        const $address_widget    = $('#address-widget');
        const $zip_code          = $('#zip');
        const $city              = $('#city');
        const $sbbu_yes          = $('#sbbu-yes');
        const $sbbu_no           = $('#sbbu-no');
        const $sbbu_provider     = $('#sbbu-provider');
        const $installation_date = $('#installation-date');
        const $cookie_warning    = $('#cookie-warning');

        win.HIPER = {};

        if ($.ie) {
            $[addClass]($html, 'ie-v' + $.ie);
        }

        // region: Load full fonts
        if ('fonts' in doc) {
            const cervo_300 = new FontFace(
                'Cervo',
                'url(/fonts/cervo-light-full.woff2) format(\'woff2\'), url(/fonts/cervo-light-full.woff) format(\'woff\')',
                {weight: '300'},
            );

            const cervo_400 = new FontFace(
                'Cervo',
                'url(/fonts/cervo-regular-full.woff2) format(\'woff2\'), url(/fonts/cervo-regular-full.woff) format(\'woff\')',
                {weight: '400'},
            );

            const cervo_300_italic = new FontFace(
                'Cervo',
                'url(/fonts/cervo-light-italic-full.woff2) format(\'woff2\'), url(/fonts/cervo-light-italic-full.woff) format(\'woff\')',
                {weight: '300', style: 'italic'},
            );

            const cervo_400_italic = new FontFace(
                'Cervo',
                'url(/fonts/cervo-regular-italic-full.woff2) format(\'woff2\'), url(/fonts/cervo-regular-italic-full.woff) format(\'woff\')',
                {weight: '400', style: 'italic'},
            );

            const montserrat_variable = new FontFace(
                'Montserrat',
                'url(/fonts/montserrat-variable-full.woff2) format(\'woff2\'), url(/fonts/montserrat-variable-full.woff) format(\'woff\')',
                {weight: '100 900'},
            );

            Promise.all([
                cervo_300.load(),
                cervo_400.load(),
                cervo_300_italic.load(),
                cervo_400_italic.load(),
                montserrat_variable.load(),
            ]).then(fonts => fonts.forEach(font => doc.fonts.add(font)));
        }
        // endregion: Load full fonts

        // region: Netinfo request
        const $dsl_product = $('#dsl-product');
        if ($dsl_product) {
            $dsl_product.forEach(dsl_product => {
                const $dsl_speed   = $('#product-list-dsl-speed');
                const url          = dsl_product.getAttribute('data-url');
                const orderId      = dsl_product.getAttribute('data-order-id');
                const offlineSpeed = dsl_product.getAttribute('data-offline-speed');
                const fields       = {
                    'order_id': orderId,
                };

                let offlineSet = false;

                $[addClass](dsl_product, 'netinfo--sending');

                $.activity_counter++;

                let netinfoTimeout = setTimeout(() => {
                    $[addClass](dsl_product, 'netinfo--not-received');
                    dsl_product.innerHTML = offlineSpeed;
                    offlineSet             = true;
                    $.activity_counter--;
                }, 60000);

                $.xhr
                    .post(url, $.parseParams(fields))
                    .success(data => {
                        if (offlineSet) {
                            return;
                        }
                        if (data.success) {
                            clearTimeout(netinfoTimeout);
                            $.activity_counter--;

                            let down  = Math.round(data.down);
                            let up    = Math.round(data.up);
                            let inner = '';

                            if (down < 1) {
                                down = '0,5';
                            }
                            if (up < 1) {
                                up = '0,5';
                            }
                            win.HIPER.netinfo = {
                                'up':   up,
                                'down': down,
                            };
                            $[addClass](dsl_product, 'netinfo--received');
                            inner                  = '<span class="speed">' + down + '<span class="thin-slash">/</span>' + up + '</span><span class="mbit">Mbit</span>';
                            dsl_product.innerHTML = inner;
                        } else {
                            clearTimeout(netinfoTimeout);
                            $.activity_counter--;

                            $[addClass](dsl_product, 'netinfo--not-received');
                            dsl_product.innerHTML = offlineSpeed;
                        }
                    })
                    .error(() => {
                        if (offlineSet) {
                            return;
                        }

                        clearTimeout(netinfoTimeout);
                        $.activity_counter--;

                        $[addClass](dsl_product, 'netinfo--not-received');
                        $dsl_speed.innerHTML = offlineSpeed;
                    });
            });
        }
        // endregion: Netinfo request

        // region: Address search

        if ($address_widget) {
            const $address_field        = $('#address-field');
            const $address_propositions = $('#address-propositions');
            const $address_list         = $('#address-list');
            const $address_not_found    = $('#address-not-found');
            const $address_wrap         = $('#address-wrap');
            const $search_error         = $('#search-error');
            const $continue_button      = $('#continue-button');
            const no_submit             = $address_widget.getAttribute('data-no-submit') === 'true';
            const default_address       = $address_widget.getAttribute('data-default-value');
            const default_address_data  = $address_widget.getAttribute('data-default-dawa-data-value');

            const _commonNavigate = data => {
                if (!data || !$address_field.value) {
                    return;
                }
                if (!no_submit) {
                    $('#send-dawa-address').submit();
                }
            };

            const navigateFromList = data => {
                $[removeClass]($address_widget, 'typing');
                $[removeClass]($html, 'address-lookup-typing');
                $[removeClass]($address_propositions, 'visible');
                $[addClass]($html, 'address-lookup-typing-found');
                $[removeClass]($continue_button, 'state-search');
                $[addClass]($continue_button, 'state-go');

                if ($address_field.getAttribute('data-address-found') !== '') {
                    _commonNavigate(data);
                }

                $('#dawa_data').value = JSON.stringify(data);
                $address_field.setAttribute('data-address-found', $address_field.value);
            };

            dawa.init({
                addressField:     $address_field,
                addressList:      $address_list,
                navigateFromList: navigateFromList,
            });

            $address_field[addEvent]('focus', event_focus => {
                if (event_focus.target.value === default_address) {
                    event_focus.target.value = '';
                    event_focus.target.setAttribute('data-address-found', '');
                    $('#dawa_data').value = '';
                }
            });

            $address_field[addEvent]('blur', event_blur => {
                if (event_blur.target.value === '' && default_address) {
                    event_blur.target.value = default_address;
                    event_blur.target.setAttribute('data-address-found', default_address);
                    $('#dawa_data').value = default_address_data;
                }
            });

            $address_field[addEvent]('input', Timeout.debounce(event_keyup => {
                const keyCode     = (win.event) ? event_keyup.which : event_keyup.keyCode;
                const ignoreCodes = Object.keys(key_codes).map(key => key_codes[key]);
                const target      = event_keyup.target;

                if (target.value.length > 1 && target.getAttribute('data-address-found') !== target.value) {
                    target.setAttribute('data-address-found', '');
                    $('#dawa_data').value = '';

                    $[addClass]($address_widget, 'typing');
                    $[addClass]($html, 'address-lookup-typing');
                    $[addClass]($address_propositions, 'visible');

                    $[addClass]($continue_button, 'state-search');
                    $[removeClass]($continue_button, 'state-go');

                    if (ignoreCodes.indexOf(keyCode) === -1) {
                        dawa.search(target.value, false, target, $address_list, $address_wrap);
                    }
                } else {
                    $[removeClass]($address_widget, 'typing');
                    $[removeClass]($html, 'address-lookup-typing');
                    $[removeClass]($address_propositions, 'visible');
                }
                if (target.value.length < 1) {
                    $[removeClass]($html, 'address-lookup-typing-found');
                }
            }, 250));

            $address_field[addEvent]('keydown', event_keydown => {
                const key = event_keydown.keyCode || event_keydown.which;
                if (event_keydown.target.value.length > 1) {
                    if (key === key_codes.UP_ARROW) {
                        dawa.navigateUp($address_list);
                        event_keydown[preventDefault]();
                    }
                    if (key === key_codes.DOWN_ARROW) {
                        dawa.navigateDown($address_list);
                        event_keydown[preventDefault]();
                    }
                    if (key === key_codes.ENTER) {
                        dawa.navigateSelect(navigateFromList);
                        event_keydown[preventDefault]();
                    }
                }
            });

            $continue_button[addEvent]('click', e => {
                dawa.navigateSelect(navigateFromList);
                e[preventDefault]();
            });

            if ($address_not_found) {
                $address_not_found[addEvent]('click', e => {
                    $[addClass]($html, 'show-manual-address');
                    $[addClass]($html, 'hide-dawa-address');
                    $[addClass]($html, 'address-lookup-typing');
                    $[removeClass]($address_widget, 'typing');
                    $('#dawa_data').value = '';

                    if ($address_field.value.length > 0) {
                        $('#street').value = $address_field.value.replace(/[\d,.:/\\;'"]|\s[\d,.:/\\;'"]/ig, '');
                    }

                    e[preventDefault]();
                });
            }

            if ($search_error) {
                $search_error[addEvent]('click', e => {
                    $[addClass]($html, 'show-manual-address');
                    $[addClass]($html, 'hide-dawa-address');
                    $[addClass]($html, 'address-lookup-typing');
                    $[removeClass]($address_widget, 'typing');

                    e[preventDefault]();
                });
            }
        }
        // endregion: Address search

        // region: Zipcode
        if ($zip_code && $city) {
            $zip_code[addEvent]('keyup', event_keyup => {
                const target = event_keyup.target;

                if (target.value.length > 4) {
                    target.value = target.value.substr(0, 4);
                }
                if (target.value.length === 4) {
                    //todo: WTF city?
                    dawa.findCityByZip(target.value, win.city);
                }
            });
        }
        // endregion: Zipcode

        // region: SBBU functionality
        if ($sbbu_yes && $sbbu_no && $sbbu_provider) {
            $sbbu_yes[addEvent]('change', event_change => {
                if (event_change.target.checked) {
                    $[addClass]($('#sbbu-details'), 'visible');
                    $sbbu_provider.setAttribute('required', '');
                    $('#sbbu_reference').setAttribute('required', '');
                }
            });
            $sbbu_no[addEvent]('change', event_change => {
                if (event_change.target.checked) {
                    $[removeClass]($('#sbbu-details'), 'visible');
                    $sbbu_provider.removeAttribute('required');
                    $('#sbbu_reference').removeAttribute('required');
                    $('#sbbu-custom-provider input').removeAttribute('required');
                }
            });
        }
        if ($sbbu_provider) {
            $sbbu_provider[addEvent]('change', () => {
                const chosen_sbbu = $('#sbbu-provider').item($('#sbbu-provider').selectedIndex);
                const chosen_sbbu_text = chosen_sbbu.attributes['data-helptext'].value;

                if (chosen_sbbu.attributes['data-requires-custom'].value) {
                    $[removeClass]($('#sbbu-custom-provider'), 'sbbu-custom-provider-hidden');
                    $('#sbbu-custom-provider input').setAttribute('required', '');
                } else {
                    $[addClass]($('#sbbu-custom-provider'), 'sbbu-custom-provider-hidden');
                    $('#sbbu-custom-provider input').removeAttribute('required');
                }
                $('#sbbu-hint').innerHTML = chosen_sbbu_text;
            });
        }
        // endregion: SBBU functionality

        // region: Installation datepicker
        if ($installation_date) {
            const $installation_date_no      = $('#specify-installation-date-no');
            const $installation_date_yes     = $('#specify-installation-date-yes');
            const $installation_date_details = $('.installation-date');

            win.flatpickr('#installation-date', {
                dateFormat:            'Y-m-d',
                altFormat:             null,
                altInput:              null,
                maxDate:               null,
                disable:               null,
                shorthandCurrentMonth: false,
                inline:                true,
                prevArrow:             '&#9664;',
                nextArrow:             '&#9654;',
            });

            $installation_date_no[addEvent]('change', event_change => {
                if (event_change.target.checked) {
                    $[removeClass]($installation_date_details, 'visible');
                }
            });

            $installation_date_yes[addEvent]('change', event_change => {
                if (event_change.target.checked) {
                    $[addClass]($installation_date_details, 'visible');
                }
            });
        }
        // endregion: Installation datepicker

        const $order_type = $('.contact__order-type');
        if ($order_type) {
            const ORDER_TYPE_PRIVATE   = $('#order-type-private').value;
            const ORDER_TYPE_BUSINESS  = $('#order-type-business').value;
            const $invoice             = $('.contact__invoice');
            const radios               = $('input[type=radio]', $order_type);
            const $invoice_email       = $('#invoice_email');
            const $invoice_first_name  = $('#invoice_first_name');
            const $invoice_last_name   = $('#invoice_last_name');
            const $contact_first_name  = $('#first_name');
            const $contact_last_name   = $('#last_name');
            const $contact_email       = $('#contact__email');
            const $invoice_phone       = $('#invoice_phone_no');
            const $contact_mobile      = $('#contact__mobile_no');
            const default_address      = $('#address-widget').getAttribute('data-default-value');
            const default_address_data = $('#address-widget')
                .getAttribute('data-default-dawa-data-value');
            const $invoice_address     = $('#address-field');

            const radioCallback = event_click => {
                if (event_click.target.value === ORDER_TYPE_PRIVATE) {
                    $[removeClass]($invoice, 'visible');
                    $('input', $invoice).toArray().forEach(element => element.tabIndex = '-1');

                    $invoice[addEvent]('transitionend', function transition_callback(event) {
                        if ($('input[name=order-type]:checked').value === ORDER_TYPE_PRIVATE) {
                            let inputs = $('input', $invoice);
                            for (let i = 0; i < inputs.length; i++) {
                                inputs[i].value = '';
                            }

                            $[removeClass]($html, 'address-lookup-*');
                            $[removeClass]($html, 'hide-*-address');
                            $[removeClass]($html, 'show-*-address');
                            $[removeClass]($address_widget, 'typing');
                            $[removeClass]($('#address-propositions'), 'visible');
                            $[removeClass]($('#continue-button'), 'state-go');
                            $[addClass]($('#continue-button'), 'state-search');

                            $invoice_address.setAttribute('data-address-found', '');
                            $('#dawa_data').value = '';

                        }
                        event.target.removeEventListener(event.type, transition_callback);
                    });
                }
                if (event_click.target.value === ORDER_TYPE_BUSINESS) {
                    $[addClass]($invoice, 'visible');
                    $('input', $invoice).toArray().forEach(element => element.tabIndex = '');

                    $invoice[addEvent]('transitionend', function transition_callback(event) {
                        if ($('input[name=order-type]:checked').value === ORDER_TYPE_BUSINESS) {
                            $invoice_first_name.value = $contact_first_name.value;
                            $invoice_last_name.value  = $contact_last_name.value;
                            $invoice_email.value      = $contact_email.value;
                            $invoice_phone.value      = $contact_mobile.value;
                            $invoice_address.value    = default_address;
                            $invoice_address.setAttribute('data-address-found', default_address);
                            $('#dawa_data').value = default_address_data;
                        }
                        event.target.removeEventListener(event.type, transition_callback);
                    });
                }
            };

            for (let i = 0; i < radios.length; i++) {
                radios[i][addEvent]('click', radioCallback);
            }
        }

        // region: SBBU datepicker
        if ($('#sbbu-date')) {
            win.flatpickr('#sbbu-date', {
                dateFormat:            'Y-m-d',
                altFormat:             null,
                altInput:              null,
                //maxDate:               null,
                disable:               null,
                shorthandCurrentMonth: false,
                inline:                true,
                prevArrow:             '&#9664;',
                nextArrow:             '&#9654;',
            });
        }
        // endregion: SBBU datepicker

        // region: Form Validation
        const registerContactInfo       = $('#register-contact-info')
        const registerCampaignCode      = $('#register-campaign-code')
        const warning                   = $('#continue-campaign-code-warning')

        validateForm(registerContactInfo, ['checkbox', 'submit']);
        validateForm($('.sbbu-form-dsl'), ['checkbox', 'submit']);
        validateForm($('.sbbu-form'),  ['submit']);
        validateForm($('#register-installation'));
        validateForm($('#register-products-not-found'));

        // check that we have no contact info already before we submit the campaign code.
        // else we throw out the contact info when we submit this, if they wrote anything
        validateForm(registerCampaignCode, ['submit'], (e, elements, any_empties) => {
            // no need to validate if there is some contact info if the campaign code is empty
            if (any_empties) {
                return false
            }

            if (registerContactInfo === null) {
                return false
            }

            registerContactInfo.toArray().forEach(function(el) {
                // only check tel, email and text fields
                if (el.required && !['radio', 'checkbox'].includes(el.type)) {
                    if (el.value === '') {
                        return true
                    }

                    warning.classList.add('visible')
                    contactFormContinueButton.classList.add('shimmer')

                    e.preventDefault()
                    return false
                }
            })
        });

        /**
         * Manual address validation
         */
        const $manual_address = $('#send-manual-address');
        if ($manual_address) {
            $manual_address[addEvent]('submit', event_submit => {
                let any_errors = false;
                [$('#street'), $('#house'), $('#zip')].forEach(element => {
                    if (element.value === '') {
                        $[addClass](element, 'error');
                        element[addEvent]('keyup', event_keyup => {
                            if (event_keyup.target.value.length > 0) {
                                $[removeClass](event_keyup.target, 'error');
                            }
                        });
                        any_errors = true;
                    } else {
                        $[removeClass](element, 'error');
                    }
                });
                if (any_errors === true) {
                    event_submit[preventDefault]();
                } else {
                    if (submitted_forms.indexOf($manual_address) !== -1) {
                        event_submit[preventDefault]();
                        return;
                    }
                    submitted_forms.push($manual_address);
                }
            });
        }

        /**
         * Order Summary checkbox validation
         */
        const $order_complete = $('#order-complete');
        if ($order_complete) {
            $order_complete[addEvent]('submit', e => {
                if ($('#accept-conditions').checked === false) {
                    $[addClass]($('#accept-conditions'), 'error');
                    e[preventDefault]();
                } else {
                    $[removeClass]($('#accept-conditions'), 'error');

                    if (submitted_forms.indexOf($order_complete) !== -1) {
                        e[preventDefault]();
                        return;
                    }
                    submitted_forms.push($order_complete);
                }
            });
        }

        const $mailcheck_fields = $('.mailcheck');
        if ($mailcheck_fields) {
            $mailcheck_fields.toArray().forEach(field => {
                const $suggestion       = $(field.getAttribute('data-mailcheck-suggestion'));
                const $suggestion_link  = $(field.getAttribute('data-mailcheck-suggestion-link'));
                const $suggestion_email = $(field.getAttribute('data-mailcheck-suggestion-email'));

                field[addEvent]('blur', () => {
                    win.Mailcheck.run({
                        email: field.value,

                        suggested: suggestion => {
                            $suggestion_email.innerHTML = suggestion.full;
                            $suggestion_link.setAttribute(
                                'data-mailcheck-suggestion-email-value',
                                suggestion.full,
                            );
                            $[addClass]($suggestion, 'visible');
                        },

                        empty: () => $[removeClass]($suggestion, 'visible'),
                    });
                });
                $suggestion_link[addEvent]('click', e => {
                    field.value = $suggestion_link.getAttribute('data-mailcheck-suggestion-email-value');
                    field.focus();
                    $[removeClass]($suggestion, 'visible');
                    e[preventDefault]();
                });
            });
        }

        // endregion: Form Validation

        // region: Overlay Functionality
        const $overlays = $('.wl-overlay');
        if ($overlays) {
            $overlays.toArray().forEach(wl_overlay => wl_overlay[addEvent]('click', overlay => {
                if (overlay.target === wl_overlay) {
                    $[removeClass](overlay.target, 'visible');
                }
            }));
        }

        const $close_links = $('.wl-overlay__close-link');
        if ($close_links) {
            $('.wl-overlay__close-link')
                .toArray()
                .forEach(close_link => close_link[addEvent]('click', event_click => {
                    const target = event_click.target;
                    if (target[parent].className === 'products-show-call-me') {
                        $[addClass](target[parent], 'hidden');
                        event_click[preventDefault]();
                        $.cookieSet('hiper-hide-products-show-call-me', '1', 7);
                        return;
                    }
                    $[removeClass](target[parent][parent], 'visible');
                    $('.wl-overlay').toArray().forEach(function(wl_overlay) {
                        $[removeClass](wl_overlay, 'visible');
                    });
                    event_click[preventDefault]();
                }));
        }
        // endregion: Overlay Functionality

        // region: Product Card Functionality
        const $product_cards = $('.order .product-list-link');
        if ($product_cards) {
            $product_cards.toArray().forEach(product_link => product_link[addEvent]('click', e => {
                const is_enabled = $[hasClass](product_link[parent], 'enabled');
                const ecommerce  = product_link.getAttribute('data-ecommerce-script-onclick');

                if (ecommerce) {
                    win.dataLayer = win.dataLayer || [];
                    win.dataLayer.push(JSON.parse(ecommerce));
                    return;
                }

                e[preventDefault]();
            }));
        }
        // endregion: Product Card Functionality

        // region: Cookie Warning
        if ($cookie_warning) {
            $('#accept-cookies')[addEvent]('click', e => {
                $.cookieSet('hiper-cookies-accepted', '1', 365);
                $cookie_warning.style.display = 'none';
                e[preventDefault]();
            });

            if ($.cookieGet('hiper-cookies-accepted') === '1') {
                $cookie_warning.style.display = 'none';
            }
        }
        // endregion: Cookie Warning

        $[addClass]($html, 'loaded');
    });

    // region: accordion
    const $accordionButton = $('.accordion');
    if ($accordionButton) {
        $accordionButton.forEach((accordion) => {
            accordion.onclick = function() {
                let content      = this.nextElementSibling;
                const noJsHeight = content.classList.contains('no-js-height');

                this.classList.toggle('active');
                content.classList.toggle('active');

                if (content.style.maxHeight && !noJsHeight) {
                    content.style.maxHeight = null;
                } else if (!content.style.maxHeight && !noJsHeight) {
                    content.style.maxHeight = content.scrollHeight + 'px';
                }
            };

            // Recalculate content height, if window is resized and max-height is smaller than scrollHeight
            window.addEventListener('resize', () => {
                if (accordion.classList.contains('active') && !accordion.nextElementSibling.classList.contains('no-js-height')) {
                    let content = accordion.nextElementSibling;

                    if (content.style.maxHeight.replace('px','') < content.scrollHeight) {
                        content.style.maxHeight = content.scrollHeight + 'px';
                    }
                }
            });
        });
    };
    // end region: accordion

    // region: navigation
    // burger menu
    const $nav       = $('.site-navigation-container');
    const $burger    = $('.burger-menu');
    const $spies     = $('.spies-banner');
    const $spiesCont = $('.spies-banner-container');

    if ($spiesCont) {
        $spiesCont.style.height = $spies.offsetHeight + "px"; // Set height of container
    }

    $burger.onclick = function() {
        $nav.classList.toggle('menu-open');

        if ($spiesCont) {
            if ($nav.classList.contains('menu-open')) {
                $spiesCont.style.marginTop = "-" + $spies.offsetHeight + "px"; // Hide banner
            } else {
                $spiesCont.style.marginTop = 0; // Show banner
            }
        }

        // Stops body scrolling on menu-open
        if ($('body').style.overflowY === "hidden") {
            $('body').style.overflowY = "scroll";
        } else {
            $('body').style.overflowY = "hidden";
        }
    };

    // drop down
    const $dropdown = $('.dropdown-button');
    if ($dropdown) {
        $dropdown.toArray().forEach((dropDown) => {
            dropDown.onclick = function() {
                // If it looks stupid but works, it ain't stupid
                this.parentNode.parentNode.parentNode.classList.toggle('active');
            };
        });
    };

    // remove open burger menu and open dropdown if window is resized above 600px
    window.addEventListener('resize', () => {
        if ($spiesCont) {
            $spiesCont.style.height = $spies.offsetHeight - 1 + "px"; // Update banner height on resize

            if ($nav.classList.contains('menu-open')) { // If burger menu is open, do...
                if (window.innerWidth <= 730) { // If mobile, do...
                    if ($spiesCont.style.marginTop != 0 ) { // If margin-top is not 0, do...
                        $spiesCont.style.marginTop = "-" + $spies.offsetHeight + "px"; // Match margin-top to height on resize
                    }
                }

                if (window.innerWidth > 730) { // If not mobile, do...
                    if ($spiesCont.style.marginTop != 0) { // If margin-top not 0, do...
                        $spiesCont.style.marginTop = 0; // Show banner
                    }
                }
            }
        }

        if (window.innerWidth > 730) {
            // remove burger .menu-open
            if ($nav.classList.contains('menu-open')) {
                $nav.classList.remove('menu-open');
                // make body scrollable again
                $('body').style.overflowY = 'scroll';
            }
            // remove dropdown .active
            $('.navigation-link--dropdown').toArray().forEach((nav_dropdown) => {
                if ($[hasClass](nav_dropdown, 'active')) {
                    nav_dropdown.classList.remove('active');
                }
            });
        }
    });
    // end region: navigation

    // region: Order Change Address
    const $changeAddressButton = $('#changeAddressButton')
    if ($changeAddressButton) {
        const $addressCancel = $('#changeAddressCancel')
        const $addressOverlay = $('.changeable-overlay')
        const $addressWarning = $('.changeable-warning')

        $changeAddressButton.onclick = function(e) {
            e.preventDefault;

            $addressWarning.style.display = 'block';
            $addressOverlay.style.display = 'block';
        }

        $addressCancel.onclick = function(e) {
            e.preventDefault;

            if ($addressWarning.style.display === 'block') {
                $addressWarning.style.display = 'none';
                $addressOverlay.style.display = 'none';
            }
        }

        $addressOverlay.onclick = function() {
            if ($addressWarning.style.display === 'block') {
                $addressWarning.style.display = 'none';
                $addressOverlay.style.display = 'none';
            }
        }
    }
    // end region: Order Change Address

    // region: Order Summary Expand
    const $summaryExpandable = $('.expand-summary-table');
    if ($summaryExpandable) {
        $summaryExpandable.forEach((button) => {
            button.onclick = function() {
                this.classList.toggle('visible');
            };
        });
    }
    // end region: Order Summary Expand

    // start region: Get OS
    const $heroContainer = $('#hero-container');

    if ($heroContainer) {
        function getOS() {
            const userAgent        = window.navigator.userAgent,
                  platform         = window.navigator?.userAgentData?.platform || window.navigator.platform,
                  macosPlatforms   = ['macOS', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
                  windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
                  iosPlatforms     = ['iPhone', 'iPad', 'iPod'];
            let os = null;

            if (macosPlatforms.indexOf(platform) !== -1) {
                os = 'mac';
            } else if (iosPlatforms.indexOf(platform) !== -1) {
                os = 'ios';
            } else if (windowsPlatforms.indexOf(platform) !== -1) {
                os = 'windows';
            } else if (/Android/.test(userAgent)) {
                os = 'android';
            } else if (/Linux/.test(platform)) {
                os = 'linux';
            }

            return os;
        }

        $heroContainer.classList.add(getOS());
    }
    // end region: Get OS

})(document, window, window.location, window.hoax);
